import { createHelpers } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';
import { AuditLog } from '@/models/supporting/AuditLog';
import { AuditQuery } from '@/models/supporting/AuditQuery';
import { HTTP } from '@/http-common';
export const { mapFields: mapAuditFields } = createHelpers({
  getterType: `orders/audit/getField`,
  mutationType: `orders/audit/updateField`,
});

export const { mapMultiRowFields: mapAuditMultiRowFields } = createHelpers({
  getterType: 'orders/audit/getField',
  mutationType: 'orders/audit/updateField',
});

import { getField, updateField } from 'vuex-map-fields';

const state = {
  rows: [],
  message: new httpError(),
  query: new AuditQuery(),
};

const getters = {
  getField,
};

//Mutations
const mutations = {
  setAudit(state, audits) {
    // state.rows.length = 0;
    state.rows = audits;
  },

  setProgress(state, message) {
    state.message = message;
  },

  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setAudit', [new AuditLog({})]);
  },
  async getAuditLog({ dispatch, state }) {
    try {
      var order = await HTTP.post('support/GetAuditLog/', state.query);
      if (order.status == 200) {
        return Promise.resolve(order.data);
      } else dispatch('reset');
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting AuditLog:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveAuditLog({ commit, dispatch, rootState, state }) {
    try {
      var order = await HTTP.post(
        'order/AddAuditLog/' + rootState.orders.rows[0].orderID,
        state.rows
      );
      commit('setAuditLog', order.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'saved OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({ message: 'unable to save:' + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1].AuditLogID);
      commit('deleteRow');
    }
    try {
      var audits = await HTTP.delete(
        'order/DeleteAuditLogFromOrder/' + rootState.orders.rows[0].orderID,
        { data: rows }
      );
      return Promise.resolve(audits);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
